import {useAvailableLocks, useFetchLocks} from './hooks';
import {checkIfCurrentDayBetween} from './helpers';

export type KeysState = 'gated' | 'waiting' | 'live';

export function useKeysState() {
  const {areKeysAvailable, areLockConditionsLoading} = useAvailableLocks();
  const {locks, areLocksLoading} = useFetchLocks({enabled: areKeysAvailable});

  const isAnyDoorOpenable = Boolean(
    locks?.some(unlock =>
      checkIfCurrentDayBetween(unlock?.valid_from, unlock?.valid_through),
    ),
  );

  const state: KeysState = !areKeysAvailable
    ? 'gated'
    : isAnyDoorOpenable
    ? 'live'
    : 'waiting';

  const opensAt = locks
    ?.map(unlock => unlock?.valid_from)
    .filter(Boolean)
    .sort()[0];

  return {
    state,
    opensAt,
    isLoading: areLockConditionsLoading || (areKeysAvailable && areLocksLoading),
  };
}
